import { Skeleton } from '@neo/primitives/skeleton'

const getSkeletonWidth = (index: number): string => {
  switch (index) {
    case 1:
      return 'w-[180px]'
    case 2:
      return 'w-[145px]'
    case 3:
      return 'w-[200px]'
    default:
      return 'w-[160px]'
  }
}

export const AppSourceSkeleton = () => (
  <div className="w-full flex flex-col gap-1 max-h-[180px] pr-2 -mr-2">
    <div className="rounded-lg bg-card relative select-none">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="select-none cursor-pointer text-foreground px-1">
          <div className="flex items-center h-8">
            <div className="flex items-center gap-1 flex-1 group">
              {/* Checkbox skeleton */}
              <div className="relative flex items-center justify-center w-4 h-4 mr-1">
                <Skeleton className="w-4 h-4 rounded" />
              </div>

              {/* File icon skeleton */}
              <div className="h-6 w-6 flex items-center justify-center">
                <Skeleton className="h-4 w-4 rounded" />
              </div>

              {/* File name skeleton */}
              <span className="flex-1 text-s-400 truncate">
                <Skeleton className={`h-4 ${getSkeletonWidth(i)} max-w-full`} />
              </span>

              {/* Preview button skeleton (appears on hover) */}
              <div className="opacity-0">
                <Skeleton className="h-6 w-[50px] rounded" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
)
